<template>
    <div class="text-center">
        <ProgressSpinner strokeWidth="4" />
        <div class="mt-3 lead" v-if="!nomsg">
            {{ msg ? msg : 'Carregando...' }} 
        </div>
    </div>
</template>

<script>
export default {
    props: ['msg', 'nomsg']
}
</script>